// extracted by mini-css-extract-plugin
module.exports = {"item":"Tasks_item_kDsvH","headerText":"Tasks_headerText_A5WPE","container":"Tasks_container_3taLW","img":"Tasks_img_2iDU1","containerCount":"Tasks_containerCount_2aNwK"};